// src/components/Dashboard/StockDetailTable.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Order from '../Order/Order';
import { Heading, LoadingSpinner, LoadingContainer, DetailContainer, CloseButton, DetailTable, DetailHeader, DetailRow, DetailData, ModalOverlay, ModalContent  } from '../../styled/common';

const StockDetailTable = ({ user, material, state, onClose }) => {
  const [detailData, setDetailData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null); // State to manage error status
  const [isModalOpen, setIsModalOpen] = useState(false); // Step 1: Track if modal is open
  const [selectedOrderNo, setSelectedOrderNo] = useState(null); // Step 1: Track selected order number

  useEffect(() => {
    const fetchDetailData = async () => {
      setIsLoading(true);
      setError(null); // Reset error state before fetching

      try {
        // First API call to get the warehouse stock data
        const response = await axios.get(`/api/warehouse-stock/?material=${material}&state=${state}`);
        const warehouseData = response.data;

        if (warehouseData.length > 0) {
          const actions = warehouseData[0].actions || {};

          // Convert actions to array for easier processing
          const filteredKeys = Object.keys(actions).filter((key) => {
            const valueArray = actions[key];
            return valueArray[6] > 0;
          });

          // If there are filtered keys, make the second API call
          if (filteredKeys.length > 0) {
            const detailResponse = await axios.get('/api/salesorders', {
              params: { ids: filteredKeys.join(',') }, // Send comma-separated string
            });
            const salesOrders = detailResponse.data;

            // Merge sales orders data with relevant data from filteredKeys
            const mergedData = filteredKeys.map((key) => {
              const salesOrder = salesOrders.find((order) => order._id === key);
              const valueArray = actions[key];

              return {
                ...salesOrder,
                totalSurplusStock: valueArray[6],
              };
            });

            setDetailData(mergedData);
          } else {
            setDetailData([]);
          }
        } else {
          setDetailData([]);
        }
      } catch (error) {
        console.error('Error fetching detail data:', error);
        setError('Failed to fetch data. Please try again later.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchDetailData();
  }, [material, state]);

  const handleOrderClick = (orderNo) => {
    setSelectedOrderNo(orderNo); // Set the selected order number
    setIsModalOpen(true); // Open the modal
  };

  const handleCloseDetail = () => {
    setIsModalOpen(false); // Close the modal
    setSelectedOrderNo(null); // Clear the selected order number
  };

  if (isLoading) {
    return (
      <LoadingContainer>
        <LoadingSpinner />
      </LoadingContainer>
    );
  }

  if (error) {
    return <div>Error: {error}</div>; // Display error message
  }

  return (
    <DetailContainer>
      <CloseButton onClick={onClose}>Close</CloseButton>
      <Heading>Stock Analysis</Heading>
      <DetailTable>
        <thead>
          <tr>
            <DetailHeader>Material</DetailHeader>
            <DetailHeader>Material Description</DetailHeader>
            <DetailHeader>Associated Order</DetailHeader>
            <DetailHeader>Associated NMO</DetailHeader>
            <DetailHeader>Quantity In Stock</DetailHeader>
            <DetailHeader>Last Updated</DetailHeader>
          </tr>
        </thead>
        <tbody>
          {detailData.map((item) => (
            <DetailRow key={item._id}>
              <DetailData data-label="Material">{item.Material}</DetailData>
              <DetailData data-label="Material Description">{item['Material Description']}</DetailData>
              <DetailData
                data-label="Associated Order"
                onClick={() => handleOrderClick(item['PO Number'].split('-')[1])}
                isClickable={true}
              >
                {item['PO Number'].split('-')[1]}
              </DetailData>
              <DetailData data-label="Associated NMO">{item['Sales Order']}</DetailData>
              <DetailData data-label="Quantity In Stock">{item.totalSurplusStock}</DetailData>
              <DetailData data-label="Last Updated">{new Date(item.updatedAt).toLocaleString()}</DetailData>

            </DetailRow>
          ))}
        </tbody>
      </DetailTable>

      {isModalOpen && (
        <ModalOverlay>
          <ModalContent>
            <CloseButton onClick={handleCloseDetail}>Close</CloseButton> {/* Step 4: Add close button */}
            {/* Pass selectedOrderNo to the Order component */}
            <Order propOrderNo={selectedOrderNo} user={user}/>
          </ModalContent>
        </ModalOverlay>
      )}

    </DetailContainer>
  );
};

export default StockDetailTable;
